import UatConfig from "./UatConfig";
import DevConfig from "./DevConfig";
import ProdConfig from "./ProdConfig";
import Dialog from "../components/ui/Dialog";

const baseURL = window.location.hostname;

const getCurrentEnvironment = () => {
  // 根据不同的host name返回不同的配置
  switch (baseURL) {
    case "localhost":
      return DevConfig;
    case "bluecross.hashtechpro.com":
      return UatConfig;
    case "aiabx-d-bxcfss.aiaazure.biz": // Pre Auth UAT (BX_DEV)
      return UatConfig;
    case "wt06.bluecross.com.hk": // VHIS UAT (BX_UAT)
      return UatConfig;
    case "www.bluecross.com.hk": //VHIS prod
      return ProdConfig;
    case "bluecross.com.hk": //VHIS prod 2
      return ProdConfig;
    case "aiabx-u-superagent.aiaazure.biz": //pen-test
      return UatConfig;
    case "aiabx-u-bxaweb.aiaazure.biz": // BX_INTRANET_UAT
      return UatConfig;
    case "aiabx-bxaweb.aiaazure.biz": // BX_INTRANET_PROD
      return ProdConfig; 
    case "aiabx-u-bccrop.aiaazure.biz":  // BX_INTRANET_UAT
      return UatConfig;
    default:
      Dialog({
        title: "System config error! please contact~",
        hideCancelBtn: true,
        hideOkBtn: true,
      });
      return; //容错
  }
};

const urlConstantJs = getCurrentEnvironment();
export { getCurrentEnvironment };
export default urlConstantJs;
